import axios from "axios";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import { useQuery } from "@tanstack/react-query";

const getUserTags = async (testCaseResultId) => {
  const userDetail = localStorage.getItem("userDetail");
  if (!userDetail) throw new Error("No user details found in localStorage");


  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getUserNoteFromTCResult&testCaseResultId=${testCaseResultId}`,
  );

  return response.data;
};

export const useGetUserTagsQuery = (testCaseResultId, options) => {
  return useQuery({
    queryKey: ["userTags", testCaseResultId],
    queryFn: () => getUserTags(testCaseResultId),
    ...options,
    staleTime: 0,
  });
};

export default useGetUserTagsQuery;
